import type { FaireProductEntity } from "../../entity_types/product";

export const p_qpsfdxujuf: FaireProductEntity = {
  token: "p_qpsfdxujuf",
  type: "product",
  name: "Hevali Night & Day Bed - Nature",
  brandToken: "b_8qfvgpu7nc",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/b95dc979bf16c7061d579e22e5684cef2ad75d8ee5819d5a9b74ccdb1d03333a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8f95801063789e0dd23f0188c25dafb0e2157bf22e62bb3d049c673ba12fc13a.jpeg",
    "https://cdn.faire.com/fastly/ebdfd76e165337e9f9c3c7e868105ca635a69be279bff0a914250970421a9f6d.jpeg",
  ],
  priceDollars: 696.5,
  description:
    "The Hevali Night & Day Junior Bed from OYOY Living Design is a modern interpretation and simplified redesign of the popular Danish Hevali bed from the 1960s. With its simple expression and still timeless and durable design, the iconic piece of furniture will be a beautiful and aesthetic addition to the children's room for many years. To decorate the perfect children's room, the first thing you need is the right furniture creating just the right ambience when the child needs to sleep. With Hevali Night & Day Junior Bed, the child gets a pleasant environment to sleep in. Let the child sleep in the soft Nuku Bedding from OYOY Living Design and make it extra cozy with cushions and Best Friends from OYOY MINI. Bedtime must be associated with something pleasant and in harmonious surroundings, the child will get the best night's sleep. The bed is made of beech wood, is produced in Europe, and is delivered flat packed for minimal environmental impact. Please note that the bed comes without a mattress. The mattress size is standard and can be bought in shops selling linen, duvets, mattresses etc. The children's room is the child's own haven. We believe that the iconic Hevali Night & Day Junior Bed will create a delightful and safe space in your little one's personal sanctuary. Our Memories design Homes\n\n\nProduct Overview\n\n * Available Colors: Nature \n * Material: 100% Beech \n * Dimensions: 64.96\"L x 29.45\"W x 27.56\"H ",
  tags: [],
  msrpDollars: 1393,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:34.859Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
